module.exports = __webpack_public_path__ + "static/debugpanel-f7262de83ecb203b837d47f43224d7a3.png";